/**
 * 品牌 Logo，nav / footer 等处复用。
 * 素材来自 public/logo-mark.svg（用户提供的自制矢量图，已去除底层白色背景块
 * 使其透明，并裁剪 viewBox 去掉多余留白），通过 <img> 引入以避免把这份
 * 较大的矢量路径内联进每次渲染的 HTML 字符串。
 */
export function renderLogo(className = "mark"): string {
  return `<img class="${className}" src="/logo-mark.svg" alt="DOHORIZON" width="64" height="40" />`;
}
